export default __webpack_public_path__ + "static/media/soulbird.c866389c.jpg";